import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const disablePotentialSensors = async (sensorId) => {
  return await axios.delete(`potential-sensors/${sensorId}/enable`)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default disablePotentialSensors;